<template>
  <v-layout align-start>
  <v-flex>
    <v-data-table
      :headers="headersPemex"
      :items="agenciamientoPemexLista"
      :single-expand="singleExpand"
      :expanded.sync="expanded"
      :search="search"
      v-if="verNuevo==0"
      item-key="folioPmx"
      show-expand
      class="elevation-1"

    >

     <template v-slot:expanded-item="{ headers, item }">
      <td :colspan="headers.length">
        <div v-for="(value,index) in item.movimientosPemex">
        <v-chip class="ma-2" color="indigo" small text-color="white">
          <v-icon left>
           arrow_right
          </v-icon>
            {{item.folioPmx}}.{{index+1}}
           </v-chip>  <v-divider></v-divider>
           <v-chip class="ma-2" color="success" small >
              Soporte :  {{value.soporte}}
           </v-chip>
       
           <v-chip class="ma-2" color="orange" small text-color="white">
              Inicio : {{value.inicio | moment("dddd Do MMMM YYYY, h:mm a")}}
           </v-chip>
            
             <v-chip class="ma-2" color="orange" small text-color="white">
              Termino {{value.termino | moment("dddd Do MMMM YYYY, h:mm a")}}
           </v-chip>
            
            <v-chip class="ma-2" color="red" small text-color="white">
              Muelle :{{value.muelle}}
           </v-chip>
              
            <v-chip class="ma-2" color="pink" small text-color="white">
              Comentarios: {{value.comentarios}}
           </v-chip>
              
           <v-chip class="ma-2" color="blue" small text-color="white">
              Estadia:{{value.estadia}} - Total:{{value.total}}- Fraccion:{{value.fraccion}}
           </v-chip>
            <v-chip class="ma-2" v-if="value.embarque" color="black" small text-color="white">
              Embarque : {{value.embarque}}ton
           </v-chip>
            <v-chip class="ma-2" v-if="value.desembarque" color="black" small text-color="white">
              Desembarque : {{value.desembarque}}ton
           </v-chip>
           <v-chip class="ma-2" v-if="value.tipoMaterial" color="black" small text-color="white">
              Material : {{value.tipoMaterial}}
           </v-chip>
           <v-chip class="ma-2" v-if="value.piloto" color="purple" small text-color="white">
              Piloto : {{value.piloto}}
           </v-chip>
           <v-chip class="ma-2" v-if="value.pilotoMovimiento" color="purple" small text-color="white">
              Movimiento : {{value.pilotoMovimiento}}
           </v-chip>
           <v-divider></v-divider>
      </div>
      </td>
    </template>

    <template v-slot:item.entradaEscala="{ item }">
          {{  item.entradaEscala | moment("dddd Do MMMM YYYY, H:mm")}}
      </template>
      
          <template v-slot:item.salidaEscala="{ item }">
          {{  item.salidaEscala | moment("dddd Do MMMM YYYY, H:mm")}}
      </template>

      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-toolbar-title>Movimientos AMLS</v-toolbar-title>
          <v-divider
            class="mx-4"
            inset
            vertical
          ></v-divider>
          <v-spacer></v-spacer>
          <v-text-field class="text-xs-center" v-if="verNuevo==0" v-model="search" append-icon="search" label="Busqueda" single-line hide-details></v-text-field>
          <v-spacer></v-spacer>   
      
        <v-spacer></v-spacer> 
          <v-dialog v-model="adModal" max-width="290">
            <v-card>
              <v-card-title class="headline" v-if="adAccion==1">
                  Activar Item
              </v-card-title>
              <v-card-title class="headline" v-if="adAccion==2">
                  Desactivar Item
              </v-card-title>

              <v-card-text>
                  Estas a punto de <span v-if="adAccion==1">Activar</span>
                  <span v-if="adAccion==2">Desactivar</span> la solicitud con folio {{adNombre}}
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn @click="activarDesactivarCerrar()" color="green darken-1" flat="flat">
                  Cancelar
                </v-btn>
                 <v-btn v-if="adAccion==1" @click="activar()" color="orange darken-4" flat="flat">
                   Aprobar
                </v-btn>
                <v-btn v-if="adAccion==2" @click="desactivar()" color="orange darken-4" flat="flat">
                  Desactivar
                </v-btn>

              </v-card-actions>

            </v-card>
          </v-dialog>

      <v-dialog v-model="dialogPuerto" persistent max-width="1000px">
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="primary" small dark v-bind="attrs" v-on="on">Situacion de Puerto</v-btn>
            </template>
          <v-card>
          <v-card-title>
            <span class="text-h5">Situacion de Puerto</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" sm="6" md="4">
                   <v-radio-group v-model="situacionDePuerto" column>
                      <v-radio label="Puerto Abierto" color="blue" value="Abierto"></v-radio>
                      <v-radio label="Puerto Cerrado" color="red" value="Cerrado"></v-radio>
                   </v-radio-group>
                    
                </v-col>
                <v-col cols="12" sm="6" md="4">
                     <v-select v-model="tipoEmb" :items="tipoDeEmbarcaciones" label="para:" required></v-select>       
                  
                </v-col>
                    

              <v-col cols="12" sm="6" md="4">
                  <v-text-field-datetimepicker
                        v-model="fechaPuerto"
                        label="Hora y Fecha"
                        v-bind:properties="{
                          clearable: false,
                          outlined: false,
                          prependIcon: 'calendar',
                          appendIcon: 'av-timer',
                        }"
                          v-bind:options="{
                          tabDateTitle: 'Date',
                          tabTimeTitle: 'Time',
                          tabBackgroundColor: 'black',
                          locale: 'en-ES',
                          format: 'YYYY-MM-DD',
                          closeOnDateClick: false,
                          useSeconds: false,
                  }"
                    />         
                  
                         </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="dialogPuerto = false"
          >
            Salir
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="guardarSituacionDePuerto()"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-spacer></v-spacer>


                       <v-btn v-if="verNuevo==0" @click="mostrarNuevo()"  small>Nuevo Movimiento</v-btn> 

       <v-dialog v-model="comprobanteModal" max-width="1100px">
            <v-card>
              <v-card-title class="headline">
                    <v-card-actions>
                    <v-btn @click="ocultarComprobante()">Salir</v-btn>
                    <v-btn @click="imprimir()">
                      <v-icon>print</v-icon>Imprimir
                    </v-btn>
                  </v-card-actions>
              </v-card-title>
              <v-card-text>
                <div id="solicitudGuardia">
                    <br />
                    <br />
                    <br />
                    <br />
                    <br />
                    <header>
                    
                      <link
                        rel="stylesheet"
                        media="print"
                        href="https://stackpath.bootstrapcdn.com/bootstrap/4.4.1/css/bootstrap.min.css"
                        integrity="sha384-Vkoo8x4CGsO3+Hhxv8T/Q5PaXtkKtu6ug5TOeNV6gBiFeWPGFN9MuhOf23Q9Ifjh"
                        crossorigin="anonymous"
                      />

                      <link
                        rel="stylesheet"
                        media="screen"
                        href="https://stackpath.bootstrapcdn.com/bootstrap/4.4.1/css/bootstrap.min.css"
                        integrity="sha384-Vkoo8x4CGsO3+Hhxv8T/Q5PaXtkKtu6ug5TOeNV6gBiFeWPGFN9MuhOf23Q9Ifjh"
                        crossorigin="anonymous"
                      />
                    </header>
                    <div id="agencia">
                      <div style="float: left; margin-left:2%;margin-right:2%">
                        <img
                          style="width:100px"
                          src="data:image/png;base64,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"
                          id="imagen"
                        />
                      </div>
                    
                      <div style="float:left;margin-top:0%;margin-left:15%;margin-right:2%">
                        <p
                          style="text-align:center;margin-left:10px;margin-right:10px;font-size:16px"
                        >
                          <strong id="texto">Movimiento de Agenciamiento</strong>
                          <br />
                          <strong id="texto">AG-PMX-{{folioPmx}}</strong>
                          <br />
                        </p>
                      </div>
                      <br />

                      <br />
                      <div id="texto" style="margin-left: 66%;">
                        Ciudad del Carmen, Campeche. a: {{fecha}}
                        <br />
                      </div>
                      <br />
                      <br><br><br>
                      <p id="texto">
                       El siguiente reporte muestra los detalles de los servicios de agenciamiento realizados con la embarcación 
                      <strong id="texto">{{embarcacion.nombre}}</strong> con numero de viaje: <strong>{{numeroDeViaje}}</strong> el cual tuvo una entrada el dia  <strong id="texto">{{entradaEscala}}</strong>
                      y un desatraque el día <strong id="texto">{{salidaEscala}}</strong> en el puerto de <strong id="texto">Ciudad del Carmen</strong> con una estadia de <strong>{{estadiaReporte}}</strong> y una fraccion de 
                      <strong>{{fraccionReporte}}</strong>
                      </p> 

                    
                    </div>
                    <br />

                    <div id="agencia">
                     


                     

                   

                    <table style="width: 100%; height: 100px;">
                        <thead style=" background-color:gray; color:black;">
                          <tr>
                            <th colspan="11">Características de la Embarcación</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td id="texto" colspan="3">Nombre de la embarcación</td>
                            <td
                              id="texto"
                              colspan="8"
                              style="border-bottom: 1px solid"
                            >{{embarcacion.nombre}}</td>
                          </tr>
                          <tr>
                            <td colspan="3" style="border-color:white"></td>
                            <td colspan="8"></td>
                          </tr>
                        </tbody>

                      

                        <tbody style="border-color:white">
                          <tr>
                            <td id="texto" style="border-color:white">Tipo</td>
                            <td id="texto" style="border-bottom: 1px solid">{{embarcacion.tipo}}</td>

                            <td id="texto">Bandera</td>
                            <td id="texto" style="border-bottom: 1px solid">{{embarcacion.bandera}}</td>
                            <td id="texto">T.R.B.</td>
                            <td id="texto" style="border-bottom: 1px solid">{{embarcacion.tbr}}</td>
                            <td id="texto">Eslora</td>
                            <td id="texto" style="border-bottom: 1px solid">{{embarcacion.eslora}}</td>
                            <td id="texto">Manga</td>
                            <td id="texto" style="border-bottom: 1px solid">{{embarcacion.manga}}</td>

                            <td></td>
                          </tr>
                          <tr>
                            <td style="border-color:white"></td>
                            <td></td>

                            <td style="border-color:white"></td>
                            <td></td>
                            <td style="border-color:white"></td>
                            <td></td>
                            <td style="border-color:white"></td>
                            <td></td>
                            <td style="border-color:white"></td>
                            <td></td>
                          </tr>
                        </tbody>
                      </table>

                      <br /><br>

                       <table style="width: 100%; height: 100px; border: 1px solid #000000;">
                        <thead
                          style="background-color:gray; color:black; border: 1px solid #000000;"
                        >
                          <tr>
                            <th colspan="8">Movimientos</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr style="border: 1px solid #000000;">
                            <td
                              id="texto"
                              style="border: 1px solid #000000;font-weight:bold; text-align:center"
                            >Index</td>
                            <td
                              id="texto"
                              style="border: 1px solid #000000;font-weight:bold; text-align:center"
                            >Soporte</td>
                            <td
                              id="texto"
                              style="border: 1px solid #000000;font-weight:bold; text-align:center"
                            >Inicio</td>
                            <td
                              id="texto"
                              style="border: 1px solid #000000;font-weight:bold; text-align:center"
                            >Termino</td>
                            <td
                              id="texto"
                             style="border: 1px solid #000000;font-weight:bold; text-align:center"
                            >Muelle</td>
                             <td
                              id="texto"
                             style="border: 1px solid #000000;font-weight:bold; text-align:center"
                            >Comentarios</td>
                           <td v-if="embarcacion.tbr>500"
                              id="texto"
                              style="border: 1px solid #000000;font-weight:bold; text-align:center"
                            >Piloto</td>
                            <td v-if="embarcacion.tbr>500"
                              id="texto"
                             style="border: 1px solid #000000;font-weight:bold; text-align:center"
                            >Movimiento</td>
                            
                          
                          </tr>
                          
                          <tr v-for="(det,index) in movimientosPemex" :key="det._id">
                         <td
                              id="texto"
                              style="border: 1px solid #000000; text-align:center"
                            >{{index+1}}</td>

                            <td
                              id="texto"
                              style="border: 1px solid #000000; text-align:center"
                            >{{det.soporte}}</td>
                             <td
                              id="texto"
                              style="border: 1px solid #000000; text-align:center"
                            >{{new Date(det.inicio) | moment(" Do MMMM YYYY, H:mm ")}} </td>
                            <td
                              id="texto"
                              style="border: 1px solid #000000; text-align:center"
                            >{{new Date(det.termino) | moment(" Do MMMM YYYY, H:mm ")}}</td>
                               <td
                              id="texto"
                              style="border: 1px solid #000000; text-align:center"
                            >{{det.muelle}}</td>
                               <td
                              id="texto"
                              style="border: 1px solid #000000; text-align:center"
                            >{{det.comentarios}}</td>
                             <td  v-if="embarcacion.tbr>500"
                              id="texto"
                              style="border: 1px solid #000000; text-align:center"
                            >{{det.piloto}}</td>
                               <td  v-if="embarcacion.tbr>500"
                              id="texto"
                              style="border: 1px solid #000000; text-align:center"
                            >{{det.pilotoMovimiento}}</td>
                          
                          </tr>
                        </tbody>
                      </table><br><br>


                        <table v-if="hayMaterial==true" style="width: 100%; height: 100px; border: 1px solid #000000;">
                        <thead
                          style="background-color:gray; color:black; border: 1px solid #000000;"
                        >
                          <tr>
                            <th colspan="8">Materiales</th>
                          </tr>
                        </thead>
                        <tbody>
                          
                          <tr style="border: 1px solid #000000;">
                           <td
                              id="texto"
                              style="border: 1px solid #000000;font-weight:bold; text-align:center"
                            >Index</td>
                            <td
                              id="texto"
                              style="border: 1px solid #000000;font-weight:bold; text-align:center"
                            >Soporte</td>
                            <td
                              id="texto"
                              style="border: 1px solid #000000;font-weight:bold; text-align:center"
                            >Inicio</td>
                            <td
                              id="texto"
                              style="border: 1px solid #000000;font-weight:bold; text-align:center"
                            >Termino</td>
                            <td
                              id="texto"
                             style="border: 1px solid #000000;font-weight:bold; text-align:center"
                            >Muelle</td>
                             <td
                              id="texto"
                              style="border: 1px solid #000000;font-weight:bold; text-align:center"
                            >Embarque</td>
                            <td
                              id="texto"
                             style="border: 1px solid #000000;font-weight:bold; text-align:center"
                            >Desembarque</td>
                             
                          
                          </tr>
                          
                          <tr v-for="(det,index) in movimientosPemex" :key="det._id">
                          <td v-if="det.embarque || det.desembarque"
                              id="texto"
                              style="border: 1px solid #000000; text-align:center"
                            >{{index+1}}</td>

                            <td v-if="det.embarque || det.desembarque"
                              id="texto"
                              style="border: 1px solid #000000; text-align:center"
                            >{{det.soporte}}</td>
                             <td v-if="det.embarque || det.desembarque"
                              id="texto"
                              style="border: 1px solid #000000; text-align:center"
                            >{{new Date(det.inicio) | moment(" Do MMMM YYYY, H:mm ")}} </td>
                            <td v-if="det.embarque || det.desembarque"
                              id="texto"
                              style="border: 1px solid #000000; text-align:center"
                            >{{new Date(det.termino) | moment(" Do MMMM YYYY, H:mm ")}}</td>
                               <td v-if="det.embarque || det.desembarque"
                              id="texto"
                              style="border: 1px solid #000000; text-align:center"
                            >{{det.muelle}}</td>
                            <td v-if="det.embarque || det.desembarque"
                              id="texto"
                              style="border: 1px solid #000000; text-align:center"
                            >{{det.embarque}} ton</td>
                               <td v-if="det.embarque || det.desembarque"
                              id="texto"
                              style="border: 1px solid #000000; text-align:center"
                            >{{det.desembarque}} ton</td>
                             
                          </tr>
                        </tbody>
                      </table><br><br>

                        <table  style="width: 100%; height: 100px; border: 1px solid #000000;">
                        <thead
                          style="background-color:gray; color:black; border: 1px solid #000000;"
                        >
                          <tr>
                            <th colspan="8">Estadias</th>
                          </tr>
                        </thead>
                        <tbody>
                          
                          <tr style="border: 1px solid #000000;">
                           <td
                              id="texto"
                              style="border: 1px solid #000000;font-weight:bold; text-align:center"
                            >Index</td>
                            <td
                              id="texto"
                              style="border: 1px solid #000000;font-weight:bold; text-align:center"
                            >Soporte</td>
                            <td
                              id="texto"
                              style="border: 1px solid #000000;font-weight:bold; text-align:center"
                            >Inicio</td>
                            <td
                              id="texto"
                              style="border: 1px solid #000000;font-weight:bold; text-align:center"
                            >Termino</td>
                            <td
                              id="texto"
                             style="border: 1px solid #000000;font-weight:bold; text-align:center"
                            >Estadia</td>
                             <td
                              id="texto"
                              style="border: 1px solid #000000;font-weight:bold; text-align:center"
                            >Total</td>
                            <td
                              id="texto"
                             style="border: 1px solid #000000;font-weight:bold; text-align:center"
                            >Fraccion</td>
                             
                          
                          </tr>
                          
                          <tr v-for="(det,index) in movimientosPemex" :key="det._id">
                          <td 
                              id="texto"
                              style="border: 1px solid #000000; text-align:center"
                            >{{index+1}}</td>

                            <td
                              id="texto"
                              style="border: 1px solid #000000; text-align:center"
                            >{{det.soporte}}</td>
                             <td 
                              id="texto"
                              style="border: 1px solid #000000; text-align:center"
                            >{{new Date(det.inicio) | moment(" Do MMMM YYYY, H:mm ")}} </td>
                            <td 
                              id="texto"
                              style="border: 1px solid #000000; text-align:center"
                            >{{new Date(det.termino) | moment(" Do MMMM YYYY, H:mm ")}}</td>
                               <td
                              id="texto"
                              style="border: 1px solid #000000; text-align:center"
                            >{{det.estadia}}</td>
                            <td 
                              id="texto"
                              style="border: 1px solid #000000; text-align:center"
                            >{{det.total}} ton</td>
                               <td 
                              id="texto"
                              style="border: 1px solid #000000; text-align:center"
                            >{{det.fraccion}} ton</td>
                             
                          </tr>
                        </tbody>
                      </table>


                    </div>
                  </div>
            
              </v-card-text>
              <v-card-actions>
              </v-card-actions>
            </v-card>

          </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:item.action="{ item }">

      <v-btn
        
         color="orange"
         fab
         dark
         small
         @click="editItem(item)"
     >
     <v-icon>edit</v-icon>
     </v-btn>

    <v-btn
          v-if="item.estado==1"
         color="black"
         fab
         dark
         small
         @click="mostrarComprobante(item)"
     >
     <v-icon>assignment</v-icon>
     </v-btn>

 
      <v-dialog
        transition="dialog-bottom-transition"
        max-width="600"
      >
    
        <template v-slot:activator="{ on, attrs }">
          <v-btn
         v-if="item.estado==0"
         color="success"
         fab
         dark
         small
         v-bind="attrs"
         v-on="on"
         @click="cerrarDialogoSalida(item)"
     >
     <v-icon>check</v-icon>
     </v-btn>
        </template>
        <template v-slot:default="dialogConfirmarSalida">
          <v-card>
            <v-toolbar
              color="primary"
              dark
            >Finalizar servicio de agenciamiento</v-toolbar>
            <v-card-text>
             
            </v-card-text>
             <v-container>
              <v-row>
                 <v-col cols="12" sm="6" md="8">
                   <h5>Ingresa el horario de salida</h5>
                </v-col>
                <v-col cols="12" sm="6" md="8">
                   
                             <input type="datetime-local" v-model="salidaEscala" >
                </v-col>
              </v-row>
             </v-container>
            <v-card-actions class="justify-end">
              <v-btn
                text
                color='red'
                @click="dialogConfirmarSalida.value = false"
              >Cerrar</v-btn>
                
                <v-btn
                text
                color="success"
                @click="listo(item)"
              >Guardar</v-btn>
            </v-card-actions>
          </v-card>
        </template>
      </v-dialog>

      </template>

  
      
 
      
      <template v-slot:no-data>
        <v-btn color="primary" @click="listar()">Resetear</v-btn>
      </template>
    </v-data-table>

    <v-container grid-list-sm class="pa-4 white" v-if="verNuevo">
        <v-layout row wrap>

           <v-flex xs11 sm11 lg11 x11>
              <div>
              

                <v-expansion-panels
                  v-model="panel"
                  multiple
                >
                 


                  <v-expansion-panel >
                    <v-expansion-panel-header  style="color:#390099; font-weight:bold">Informacion</v-expansion-panel-header>
                    <v-expansion-panel-content>
                           
                        <v-row>
                            <v-col cols="3">
                                  <v-autocomplete prepend-icon="directions_boat" v-on:change="mostrarDetallesDeEmbarcacion()" label="Embarcacion" v-model="embarcacion" dense outlined :items="embarcaciones"  ></v-autocomplete>
                                      <v-alert v-if="submited && !$v.embarcacion.required" v-model="alert" dismissible color="red" border="left" elevation="1" colored-border icon="error">
                                              <strong>Error</strong> Campo embarcacion es obligatorio
                                      </v-alert>
                            </v-col>
                            
                           
                            <v-col cols="3" v-if="estado!==1">
                                <h5>Tonelada: {{datosEmbarcacion.tbr}}</h5>
                            </v-col>
                             <v-col cols="3" v-if="estado!==1">
                                <h5>Eslora: {{datosEmbarcacion.eslora}}</h5>
                            </v-col>
                             <v-col cols="3" v-if="estado!==1">
                                <h5>Bandera: {{datosEmbarcacion.bandera}}</h5>
                            </v-col>
                               <v-col cols="3" sm="3" md="3">
                         
                            <label for="">Entrada Escala</label>
                             <input type="datetime-local" v-model="entradaEscala" >
                                                  
                        </v-col>
                           <v-col cols="3" sm="3" md="3">
                                       <v-text-field-integer
                                       label="Numero de viaje"
                                  v-model="numeroDeViaje"
                                  
                                  v-bind:properties="{
                                    readonly: false,
                                    disabled: false,
                                    outlined: false,
                                    clearable: true,
                                    placeholder: '',
                                  }"
                                  v-bind:options="{
                                    inputMask: '#########',
                                    outputMask: '#########',
                                    empty: null,
                                    applyAfter: false,
                                  }"
                                  v-bind:focus="focus"
                                 focus:true
                                />     
                            
                           </v-col>

                          <v-col cols="3">
                                <v-switch v-model="switchMat" v-on:change="mostrarMat()" inset class="switch" label="¿Incluye Embarque o Desembarque de Materiales?"   color="#ff0054"  hide-details></v-switch>  
                          </v-col>


                        


                                     
                        </v-row>
                        
                         
                    </v-expansion-panel-content>
                  </v-expansion-panel>


                          <v-expansion-panel>
                    <v-expansion-panel-header style="color:#31467C; font-weight:bold">Movimientos</v-expansion-panel-header>
                    <v-expansion-panel-content>
                        <v-row>


                             <v-col cols="4">
                                  <v-autocomplete prepend-icon="assignment" v-on:change="mostrarMuelleExterno()"  label="Soporte" v-model="soporte" dense outlined :items="soportes"  ></v-autocomplete>
                            </v-col>
                              

                         
                              
                                 <v-col cols="2" v-if="soporte_info=='Posicion'">
                                   <v-btn small fab dar color="" @click="agregarMovimiento()">
                                            <v-icon dark>file_upload
                                        </v-icon>
                                    </v-btn>
                                </v-col>
                                  <v-col cols="2" v-if="soporte_info=='Atraque'">
                                   <v-btn small fab dar color="" @click="agregarMovimiento()">
                                            <v-icon dark>file_download
                                        </v-icon>
                                    </v-btn>
                                </v-col>
                                 <v-col cols="2" v-if="soporte_info=='Enmienda'">
                                   <v-btn small fab dar color="" @click="agregarMovimiento()">
                                            <v-icon dark>timeline
                                        </v-icon>
                                    </v-btn>
                                </v-col>
                                  <v-col cols="2" v-if="soporte_info=='Fuera de Servicio'">
                                   <v-btn small fab dar color="" @click="agregarMovimiento()">
                                            <v-icon dark>stop_circle
                                        </v-icon>
                                    </v-btn>
                                </v-col>
                                  <v-col cols="2" v-if="soporte_info=='Fuera de Contrato'">
                                   <v-btn small fab dar color="" @click="agregarMovimiento()">
                                            <v-icon dark>file_download_off
                                        </v-icon>
                                    </v-btn>
                                </v-col>
                        
                             <v-row v-for="(item, index) in movimientosPemex" :key="item._id">
                              
                                          <v-col cols="4">
                                      <v-text-field label="Soporte" disabled v-model="item.soporte" ></v-text-field>
                                    </v-col>

                                    

                    <v-col cols="4" sm="4" md="4">
                             
                                 <label for="">Inicio</label><br>
                             <input type="datetime-local" class="form-control" v-model="item.inicio" >
                 </v-col>
                                     <v-col cols="4">
                                     
                                   <label for="">Termino</label><br>
                             <input type="datetime-local" v-model="item.termino" >
                                    </v-col>
                                     
                                    <v-col cols="4">
                                      <v-text-field label="Muelle de Arribo" required v-model="item.muelle" ></v-text-field>
                                   
                                    </v-col>

                                     <v-col cols="4" sm="4" md="4" v-if="datosEmbarcacion.tbr>=500">
                                <v-select v-model="item.piloto" :items="pilotos" label="Piloto" required></v-select>                            </v-col>
                             <v-col cols="4" sm="4" md="4" v-if="datosEmbarcacion.tbr>=500" >
                                <v-text-field   label="Mov Piloto"   v-model="item.pilotoMovimiento" ></v-text-field>
                            </v-col>

                            <v-col v-if="materiales==true" cols="2" sm="2" md="2" >
                                <v-text-field  suffix="ton" label="Embarque"   v-model="item.embarque" ></v-text-field>
                            </v-col>

                            <v-col v-if="materiales==true" cols="2" sm="2" md="2">
                                <v-text-field suffix="ton"  label="Desembarque"   v-model="item.desembarque" ></v-text-field>
                            </v-col>

                                                        <v-col v-if="materiales==true" cols="4" sm="4" md="4">
                                <v-text-field  label="Tipo de material"   v-model="item.tipoMaterial" ></v-text-field>
                            </v-col>

                               <v-col  cols="4" sm="4" md="4">
                                <v-textarea  label="Comentarios"   v-model="item.comentarios" ></v-textarea>
                            </v-col>


                                    <v-col cols="3">
                                      <h5>Estadia: {{item.estadia}}</h5>
                                      <h5>Total: {{item.total}}</h5>
                                      <h5>Fraccion: {{item.fraccion}}</h5>
                                    </v-col>
 

                      

                                    
                                     <v-col cols="2" v-if="estado!=1">
                                          <v-btn small color="success" class="ma-2 white--text" @click="calcularFraccion(index,item)">Calcular<v-icon right dark>
                                          functions
                                          </v-icon>
                                        </v-btn>
                                      </v-col>

                                       

                                     
                                      <v-col cols="2" v-if="estado!=1">
                                          <v-btn small color="red" class="ma-2 white--text" @click="eliminarAmarradores(movimientosPemex,item)">Eliminar<v-icon right dark>
                                            delete
                                          </v-icon>
                                        </v-btn>
                                      </v-col>
                                        
                                </v-row>   
                           
                        </v-row>
                   
                    </v-expansion-panel-content>

                    
                        </v-expansion-panel>

                     


       
                </v-expansion-panels>
              </div>
            </v-flex>
            <template>
  <v-divider></v-divider>
</template>
          

         
             <v-flex xs12 sm2 md12 lg12 xl12>
            
             <v-btn class="ma-2" @click.native="guardar()" outlined color="indigo">Guardar</v-btn>
             <v-btn class="ma-2" @click.native="ocultarNuevo()" outlined color="red">Salir</v-btn>
               
              
             </v-flex>  


        </v-layout>
    </v-container>

  </v-flex>


  </v-layout>

  
</template>
<script>
import axios from "axios";

import moment from 'moment'
import swal from "sweetalert";
import emailjs from "emailjs-com";
import { required, email, minLength } from "vuelidate/lib/validators";
export default {
  icons: {
    iconfont: "fa4",
  },

  validations: {
   
        embarcacion: {
            required,
          },
          entradaEscala: {
            required,
          },
         
          
      
   

  },
  

  data() {
    return {
      search: "",
      cambiosGuardia: [],
      headersPemex: [
        { text: "Actions", value: "action", sortable: false },
        { text: "Folio", value: "folioPmx", sortable: true },
        { text: "Entrada", value: "entradaEscala", sortable: true },
        { text: "Salida", value: "salidaEscala", sortable: true },
        { text: "Embarcacion", value: "embarcacion.nombre", sortable: true },
        { text: "Usuario", value:"usuario.nombre", sortable:true},
        { text: '', value: 'data-table-expand' },
      ],
situacionDePuerto:null,
     numeroDeViaje:0,
idDialog:'',
      editedIndex: -1,
      _id: "",
      verMuelle:0,
     tipoDeEmbarcaciones:['Embarcaciones Mayores','Embarcaciones Menores'],
      embarcacion: "",
      entradaEscala:'',
      fechaPuerto:'',
      salidaEscala:'',
      inicioContrato:'',
      salidaContrato:'',
      embarcaciones: [],
    agenciamientoPemexLista:[],
  soporte_info:'',
      pilotos:['Cap. Mario Lopez','Cap. Navarrete','Cap Quiroz'],
  tipoEmb:'',
      soportes:[
          "Atraque",
          "Enmienda",
          "Posicion",
          "Fuera de Contrato",
          "Fuera de Servicio"
      ],
      soporte:'',
      dialogConfirmarSalida: false,
      menu1:false,
      manu3:false,
      movimientosPemex:[],
     embaracaionDialog:'',
      verNuevo: 0,
      usuario: "",
    folioDialog:'',
      fecha: "",
      estadia:"",
      singleExpand:'',
      movimientosAgenciamientoLista:[],
      folio: "",
     folioPmx:'',
      datosEmbarcacion:[],
    dialogPuerto:false,
      detalles: "",
      expanded:[],
      estado:'',
      embarcacionDialog:'',
      adModal: 0,
      submited: "",
      submited2:"",
      dialog: false,
      modal: "",
          panel: [0, 1, 2, 3, 4],
focus:'',
      on: "",
      comprobanteModal: 0,
      adAccion: 0,
      nombreCompleto: "",
      cargo: "",
      adNombre: "",
      adId: "",
      deadline1ts:'',
      switchMat:'',
      materiales:'',
      entradaDialog:'',
      estadiaEscala:'',
      fraccionEscala:'',
      estadiaReporte:'',
      agenciamientoReporte:'',
      //Reporte
      estadiasTotales:[],
      folioAg:'',
      atraqueFecha:'',
      desatraqueFecha:'',
      pilotoSalida:'',
    hayMaterial:'',
      value: Date.now(),
dialogoDePrueba:false,
salidaDeContratoDialog:false,
  hayPiloto:'',

    };
  },
  computed: {
   
    formTitle() {
      return this.editedIndex === -1 ? "Nuevo Movimiento" : "Editar Movimiento";
    },

   
  },
  computed:{
     fechaInicialParaCotizar: function () {
      return this.deadline1ts
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  created() {
    this.listar();
    this.selectEmbarcaciones();
    this.emailIn();
  },

  methods: {
 
    imprimir() {
    
      const modal = document.getElementById("solicitudGuardia")
      const cloned = modal.cloneNode(true)
      let section = document.getElementById("print")

      if (!section) {
        section  = document.createElement("div")
        section.id = "print"
        document.body.appendChild(section)
      }

      section.innerHTML = "";
      section.appendChild(cloned);
      window.print();
    },

    mostrarComprobante(item) {
      this.limpiar();
      this.embarcacion = item.embarcacion;
      this.folioPmx = item.folioPmx
      var fecha = new Date();
      var options = { year: 'numeric', month: 'long', day: 'numeric' };
      this.fecha = fecha.toLocaleDateString("es-ES", options);
      var entradaEscala = new Date(item.entradaEscala)
      this.entradaEscala = entradaEscala.toLocaleDateString("es-Es",options);
      var salidaEscala = new Date(item.salidaEscala)
      this.salidaEscala = salidaEscala.toLocaleDateString("es-Es",options);
      this.movimientosPemex = item.movimientosPemex
      this.hayMaterial = item.hayMaterial
      this.comprobanteModal = 1;
      this.numeroDeViaje = item.numeroDeViaje
      this.estadiaReporte = item.estadia
      this.fraccionReporte = item.fraccion
    
    },
    ocultarComprobante() {
      this.comprobanteModal = 0;
           

    },

    mostrarNuevo() {
      this.limpiar();
      this.verNuevo = 1;
     
    },
    ocultarNuevo() {
      this.verNuevo = 0;
      this.limpiar();
    },

  
     eliminarAmarradores(arr, item) {
      let i = arr.indexOf(item);
      if (i != -1) {
        arr.splice(i, 1);
      }
    },

    dialogPrueba(){
      this.dialogPrueba = true
    },

    emailIn() {
      emailjs.init("user_QA8qMBuyHCQIHTgR0AsPx");
    },

      enviar(embarcacion,entradaEscala,salidaEscala,usuario){
                 

         var template_params = {
             "embarcacion":embarcacion,
              "entradaEscala": entradaEscala,
              "salidaEscala": salidaEscala,
              "usuario": usuario,
                        }
                        
               emailjs.send("gmail","EntradaAgenciamientoPeme", template_params)
                .then(function(response) {
                   if(response.text === 'OK'){        
                  }
                    console.log("SUCCESS. status=%d, text=%s", response.status, response.text);
                  }, function(err) {
                  alert('Ocurrió un problema al enviar el correo');
                console.log("FAILED. error=", err);
             });
                
       },

        enviar2(embarcacion,entradaEscala,salidaEscala,usuario){
                 

         var template_params = {
             "embarcacion":embarcacion,
              "entradaEscala": entradaEscala,
              "salidaEscala": salidaEscala,
              "usuario": usuario,
                        }
                        
               emailjs.send("gmail","SalidaAgenciamientoPemex", template_params)
                .then(function(response) {
                   if(response.text === 'OK'){        
                  }
                    console.log("SUCCESS. status=%d, text=%s", response.status, response.text);
                  }, function(err) {
                  alert('Ocurrió un problema al enviar el correo');
                console.log("FAILED. error=", err);
             });
                
       },
     
      

     listarEmbarcacion(embarcacion,entradaEscala,salidaEscala,usuario){
            let header={"Token":this.$store.state.token};
            let me=this;
            let telefono;
            let configuracion= {headers: header}
            axios.get('embarcacion/query?_id='+embarcacion,configuracion).then(function (response){
            embarcacion=response.data;
            axios.get('usuario/query?_id='+usuario,configuracion).then(function (response){
              usuario=response.data.nombre
              telefono=response.data.telefono
              me.enviar(embarcacion,entradaEscala,salidaEscala,usuario)
              me.enviarWhatsApp(telefono,'Nuevo movimiento de Agenciamiento capturado con la embarcación '+embarcacion+' con un acceso para el día '+entradaEscala+' capturado por el usuario '+usuario)
            })
            
            }).catch(function(error){
              console.log(error)
            })
      },

        listarEmbarcacion2(embarcacion,entradaEscala,salidaEscala,usuario){
            let header={"Token":this.$store.state.token};
            let me=this;
            let configuracion= {headers: header}
            axios.get('embarcacion/query?_id='+embarcacion,configuracion).then(function (response){
            embarcacion=response.data;
            axios.get('usuario/query?_id='+usuario,configuracion).then(function (response){
              usuario=response.data.nombre
              me.enviar2(embarcacion,entradaEscala,salidaEscala,usuario)

            })
            
            }).catch(function(error){
              console.log(error)
            })
      },



    selectEmbarcaciones() {
      let me = this;
      let embarcacionArray = [];
      let header = { Token: this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get("embarcacion/listActivos", configuracion)
        .then((response) => {
          embarcacionArray = response.data;
          embarcacionArray.map(function (x) {
            me.embarcaciones.push({ text: x.nombre, value: x._id });
          });
   
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    


    mostrarDetallesDeEmbarcacion(){
      let me = this;
      let header = { Token: this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get("embarcacion/queryDatos?_id=" + this.embarcacion, configuracion)
        .then(function (response) {
          me.datosEmbarcacion = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    mostrarMuelleExterno(){
       
        this.soporte_info = this.soporte
    },

    validar() {
      this.valida = 0;
      this.validaMensaje = [];
      if (!this.embarcacion) {
        this.validaMensaje.push("La embarcación es obligatorio");
      }

      if (!this.muelle) {
        this.validaMensaje.push("El muelle es obligatoria");
      }

      if (this.validaMensaje.length) {
        this.valida = 1;
      }
      return this.valida;
    },

  
   
   
    agregarMovimiento(){
        if(this.soporte_info=='Posicion'){
       
            this.movimientosPemex.push({
             soporte:'Posicion',
                inicio:'',
                termino:'',
                comentario:'',
                piloto:'',
                pilotoMovimiento:'',
                estadia:'',
                total:'',
                fraccion:'',
                embarque:'',
                desembarque:'',
                muelle:'',
                tipoMaterial:'',
                comentarios:'',
             
            })
        }else if(this.soporte =='Atraque'){
            this.movimientosPemex.push({
                soporte:'Atraque',
                inicio:'',
                termino:'',
                comentario:'',
                piloto:'',
                pilotoMovimiento:'',
                estadia:'',
                total:'',
                fraccion:'',
                embarque:'',
                desembarque:'',
                muelle:'',
                tipoMaterial:'',
                comentarios:'',


            })
        }
        else if(this.soporte == 'Enmienda'){
            this.movimientosPemex.push({
                soporte:'Enmienda',
                 inicio:'',
                termino:'',
                comentario:'',
                piloto:'',
                pilotoMovimiento:'',
                estadia:'',
                total:'',
                fraccion:'',
                embarque:'',
                desembarque:'',
                muelle:'',
                tipoMaterial:'',
                comentarios:'',
            })
           
        }
         else if(this.soporte == 'Fuera de Servicio'){
            this.movimientosPemex.push({
                soporte:'Fuera de Servicio',
                 inicio:'',
                termino:'',
                comentario:'',
                piloto:'',
                pilotoMovimiento:'',
                estadia:'',
                total:'',
                fraccion:'',
                embarque:'',
                desembarque:'',
                muelle:'',
                tipoMaterial:'',
                comentarios:'',
            })
        }
         else if(this.soporte == 'Fuera de Contrato'){
            this.movimientosPemex.push({
                soporte:'Fuera de Contrato',
                 inicio:'',
                termino:'',
                comentario:'',
                piloto:'',
                pilotoMovimiento:'',
                estadia:'',
                total:'',
                fraccion:'',
                embarque:'',
                desembarque:'',
                muelle:'',
                tipoMaterial:'',
                comentarios:'',
            })
        }
        
      
    },

    mostrarMat(){
      if(this.switchMat == true){
        this.materiales = true
      }else{
        this.materiales = false
      }
    },


    calcularFraccion(index,item){

      if(item.inicio == '' || item.termino==''){
           swal(
              "Error",
              "Campos de inicio y termino no capturados correctamente",
              "error"
            );
      }else{
      let inicio = new Date(item.inicio)
      let termino = new Date(item.termino)

      var fecha1 = moment(inicio, "YYYY-MM-DD HH:mm:ss");
      var fecha2 = moment(termino, "YYYY-MM-DD HH:mm:ss");
      var minutos;

      var sumaDeFechas = fecha2 - fecha1;
      

      //Estadia Calculo

      let dias = (fecha2.diff(fecha1,'days'))
      var minutos = Math.floor((sumaDeFechas / 1000 / 60) << 0);

      let diasEnHoras = dias*24
      let diasEnMinutos = diasEnHoras*60

      let diferenciaDeHoras = minutos - diasEnMinutos

      let horas = Math.trunc(diferenciaDeHoras/60)

      let minutosDeEstadia = diferenciaDeHoras-(horas*60)
      let total;
      let fraccion;
     
      this.movimientosPemex[index].estadia = dias +' Dias '+ horas +' horas '+ minutosDeEstadia+' minutos'
      if(termino.getMinutes()==59){
        let horasDelDia = dias*24
        total = (horasDelDia+horas)+':'+minutosDeEstadia+':59'
        fraccion = (horasDelDia+horas)+(minutosDeEstadia/60)+.02
      }else{
        let horasDelDia = dias*24
        total = (horasDelDia+horas)+':'+minutosDeEstadia+':00'
        fraccion = (horasDelDia+horas)+(minutosDeEstadia/60)

      }

    
        let fraccionConDecimal =  this.redoNum(fraccion,2)
       
      
      this.movimientosPemex[index].total = total;
      this.movimientosPemex[index].fraccion = fraccionConDecimal;


      }
    
    },

 


    limpiar() {
              this._id=''
              this.embarcacion = '',
              this.folioPmx = '',
              this.fecha='',
              this.entradaEscala='',
              this.salidaEscala='',
              this.movimientosPemex=[];
              this.hayMaterial='',
              this.salidaContrato='',
              this.inicioContrato=''
              this.datosEmbarcacion=[],
              this.numeroDeViaje='',
        (this.valida = 0),
        (this.validaMensaje = []),
        (this.editedIndex = -1);
    },


    guardar() {
      
      let me = this;
      let header = { Token: this.$store.state.token };
      let configuracion = { headers: header };
      if(!this.switchMat){
        this.switchMat=false
      }
    
      for(let i =0; i<this.movimientosPemex.length;i++){
        this.movimientosPemex[i].inicio = new Date(this.movimientosPemex[i].inicio)
        this.movimientosPemex[i].termino = new Date(this.movimientosPemex[i].termino)      
      }
      
      for(let i =0; i<this.movimientosPemex.length;i++){
        if(new Date(this.movimientosPemex[i].inicio).getDate() < new Date(this.movimientosPemex[i].termino).getDate()){
         let corteFechaInicial = new Date(this.movimientosPemex[i].termino).setHours(0)
         corteFechaInicial = new Date(corteFechaInicial).setMinutes(0)
         corteFechaInicial = new Date(corteFechaInicial).setSeconds(0)

         this.movimientosPemex.push({
           soporte:this.movimientosPemex[i].soporte,
           inicio:new Date(corteFechaInicial),
           termino:this.movimientosPemex[i].termino,
           comentario:this.movimientosPemex[i].comentarios,
            piloto:'',
                pilotoMovimiento:'',
                estadia:'',
                total:'',
                fraccion:'',
                embarque:'',
                desembarque:'',
                muelle:this.movimientosPemex[i].muelle,
                tipoMaterial:'',
                comentarios:'',

         })
                   let corteFecha = new Date(this.movimientosPemex[i].termino).setDate(new Date(this.movimientosPemex[i].inicio).getDate())
          corteFecha = new Date(corteFecha).setHours(23)
          corteFecha = new Date(corteFecha).setMinutes(59)
          corteFecha = new Date(corteFecha).setSeconds(59)  
         this.movimientosPemex[i].termino = new Date(corteFecha)
        } 
      }

     
    
      

       this.submited = true
                  this.$v.$touch();
                  if(this.$v.$invalid){
                    swal(
                      "Error",
                      "Verificar los datos ingresados",
                      "error"
                    )
                    return false
                  }

       if (this.editedIndex > -1) {
         
        axios
          .put(
            "agenciamientoPemex/update",
            {
              _id: this._id,
              embarcacion: this.embarcacion,
              entradaEscala:new Date(this.entradaEscala),
              salidaEscala:this.salidaEscala,
              movimientosPemex:this.movimientosPemex,

              numeroDeViaje:this.numeroDeViaje,
              hayMaterial: this.switchMat
            },
            configuracion
          )
          .then(function (response) {
            
            swal(
              "Registro de agenciamiento Actualizada",
              "Solicitud de agenciamiento actualizada exitosamente",
              "success"
            );
            
            me.listar(); 
            me.limpiar();
            me.ocultarNuevo();
            me.close();
            
          })
          
          .catch(error =>{
            this.errorM=null;
            if(error.response.status==500){
              console.log('Error de captura')
            }
          });
      }
      else {
     
        if(this.datosEmbarcacion.tbr>500){
          this.hayPiloto=true
        }else{
          this.hayPiloto=false
        }
        axios
          .post(
            "agenciamientoPemex/add",
            {
              embarcacion: this.embarcacion,
              entradaEscala:this.entradaEscala,
              salidaEscala:this.salidaEscala,
              movimientosPemex:this.movimientosPemex,
            
              usuario:this.$store.state.usuario._id,        
              numeroDeViaje:this.numeroDeViaje,
              hayMaterial: this.switchMat,
              hayPiloto:this.hayPiloto
            },
            configuracion
         )
          .then(function (response) {
            swal(
              "Nuevo Servicio de Agenciamiento",
              "Servicio de Agenciamiento agregado exitosamente",
              "success"
            );
            console.log(response.data)
            me.listar()
            me.listarEmbarcacion(response.data.embarcacion,moment(response.data.entradaEscala).format('MMMM Do YYYY, h:mm:ss a'),  moment(response.data.salidaEscala ).format('MMMM Do YYYY, h:mm:ss a'), response.data.usuario )
            me.limpiar();
            me.ocultarNuevo();
            me.close();
          })
        .catch(function (error) {
            me.close();
            swal(
              "Error",
              "Error al ingresar la solicitud, verifica los datos ingresados",
              "error"
            );
          });
      }
    },

    enviarWhatsApp(number,mensaje){
        
         let header={"Token":this.$store.state.token};

          axios.post('message/sendWhastApp?number='+number+'&message='+mensaje).then(function (response){
          console.log(response)
          }).catch(function(error){
            console.log(error)
          })
      },

    guardarSituacionDePuerto(){
      let header = { Token: this.$store.state.token };
      let configuracion = { headers: header };
      let me = this;
              
      if(this.situacionDePuerto=='' || this.tipoEmb=='' || this.fechaPuerto==''){
        swal(
          "Error",
          "Error, todos los campos deben estar llenos",
          "error"
        )
      }else{
        axios
                .post(
                  "situacionDePuerto/add",
                  {
                    
                    situacionDePuerto: this.situacionDePuerto,
                    tipoEmb:this.tipoEmb,
                    fechaPuerto:this.fechaPuerto,
                  
                  },
                  configuracion
                )
                .then(function (response) {
                
                  swal(
                    "Registro de agenciamiento Actualizada",
                    "Solicitud de agenciamiento actualizada exitosamente",
                    "success"
                  );
                
                  me.dialogPuerto=false
                  
                })
                
                .catch(function (error) {
                 
                  swal(
                    "Error",
                    "Error al ingresar la solicitud, verifica los datos ingresados",
                    "error"
                  );
                });
      }
      
      },
    

 
    listar() {
      let header = { Token: this.$store.state.token };
      let configuracion = { headers: header };
      let me = this;
      axios
        .get(
          "agenciamientoPemex/list",
          configuracion
        )
        .then(function (response) {
          me.agenciamientoPemexLista = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

   
    editItem(item) {
   
      this._id = item._id
      //Informacion
      this.embarcacion = item.embarcacion._id
      this.mostrarDetallesDeEmbarcacion()
      if(item.movimientosPemex[0].embarque || item.movimientosPemex[0].desembarque){
        this.switchMat = true
        this.materiales = true
      }else{
        this.switchMat = false
        this.materiales = false
      }
      this.numeroDeViaje = item.numeroDeViaje
      this.movimientosPemex = item.movimientosPemex
      this.entradaEscala = moment(item.entradaEscala).format('YYYY-MM-DDTHH:mm')
      this.salidaEscala = new Date(item.salidaEscala)
      this.inicioContrato = new Date(item.inicioContrato)
      if(item.salidaContrato){
          this.salidaContrato = new Date(item.salidaContrato)
      }
      //
    
      for(let i=0; i<item.movimientosPemex.length;i++){
        if(this.movimientosPemex[i].inicio==null){
          this.movimientosPemex[i].inicio == ''
        }else{
        this.movimientosPemex[i].inicio = moment(new Date(item.movimientosPemex[i].inicio)).format('YYYY-MM-DDTHH:mm')
        this.movimientosPemex[i].termino = moment(new Date(item.movimientosPemex[i].termino)).format('YYYY-MM-DDTHH:mm')
        }
        
      }
      this.editedIndex = 1;
      this.dialog = false;
      this.verNuevo = 1;
    },


    

      listo(item) {
        let header = { Token: this.$store.state.token };
        let configuracion = { headers: header };
        let me = this;
        let totalFraccion=0;

        let inicio = new Date(item.entradaEscala)
        let termino = new Date(this.salidaEscala)

        console.log(inicio)
        console.log(termino)

        var fecha1 = moment(inicio, "YYYY-MM-DD HH:mm:ss");
        var fecha2 = moment(termino, "YYYY-MM-DD HH:mm:ss");
        var minutos;

        var sumaDeFechas = fecha2 - fecha1;

      let dias = (fecha2.diff(fecha1,'days'))
      var minutos = Math.floor((sumaDeFechas / 1000 / 60) << 0);

      let diasEnHoras = dias*24
      let diasEnMinutos = diasEnHoras*60

      let diferenciaDeHoras = minutos - diasEnMinutos

      let horas = Math.trunc(diferenciaDeHoras/60)

      let minutosDeEstadia = diferenciaDeHoras-(horas*60)
      let total;
      let fraccion;

      this.estadiaEscala = dias +' Dias '+ horas +' horas '+ minutosDeEstadia+' minutos'
      if(termino.getMinutes()==59){
        let horasDelDia = dias*24
        total = (horasDelDia+horas)+':'+minutosDeEstadia+':59'
        fraccion = (horasDelDia+horas)+(minutosDeEstadia/60)+.02
      }else{
        let horasDelDia = dias*24
        total = (horasDelDia+horas)+':'+minutosDeEstadia+':00'
        fraccion = (horasDelDia+horas)+(minutosDeEstadia/60)

      }
        let t=fraccion.toString();
      let regex=/(\d*.\d{0,2})/;
        let fraccionConDecimal = t.match(regex)[0];

        this.fraccionEscala =  this.redoNum(fraccion,2)
                for(let i=0; i<item.movimientosPemex.length;i++){
                  totalFraccion = (parseFloat(item.movimientosPemex[i].fraccion) + totalFraccion)
                    
                }

        console.log(item.numeroDeViaje)
          if(this.salidaEscala==''){
             
                swal(
                  "Error",
                  "Campo de salida es obligatorio",
                  "error"
                );
          }
        

          else if(this.fraccionEscala != totalFraccion){
           
          
            swal({
              title: "¿Seguro que quieres confirmar la salida?",
              text: "La fraccion de los movimientos no coincide con la fraccion de la escala\n Escala: "+this.fraccionEscala+" Movimientos: "+totalFraccion ,
              icon: "warning",
              buttons: true,
              dangerMode: true,
            })
            .then((willDelete) => {
              if (willDelete) {
                 this.finalizarEscala()
                swal("Servicio finalizado", {
                  icon: "success",
                });
              } else {
                swal("Your imaginary file is safe!");
              }
            });
          }
          else{
            this.finalizarEscala()
          }
          
        
        },
      test(){
        console.log('prueba')
      },
     finalizarEscala(){
        let header = { Token: this.$store.state.token };
      let configuracion = { headers: header };
      let me = this;
            axios
            .put("agenciamientoPemex/finalizarServicio", 
              { 
                _id: this.idDialog,
                salidaEscala:new Date(this.salidaEscala),
                fraccion: this.fraccionEscala,
                estadia: this.estadiaEscala
              },
              configuracion)
            .then(function (response) {
             
                me.listarEmbarcacion2(response.data.embarcacion,moment(response.data.entradaEscala).format('MMMM Do YYYY, h:mm:ss a'),  moment(response.data.salidaEscala ).format('MMMM Do YYYY, h:mm:ss a'), response.data.usuario )
              me.listar();       
              me.limpiar();
            
              swal(
                  "Listo",
                  "Salida de la embarcacion capturada con exito",
                  "success"
                );
            })
            .catch(function (error) {
              console.log(error);
            });
     },

      redoNum(numero, digitos, sp = true) {
    // redondear núm. procedente de operación forzamos 3º argum. a true
    function toExp(numero, digitos) {
        let arr = numero.toString().split("e");
        let mantisa = arr[0], exponente = digitos;
        if (arr[1]) exponente = Number(arr[1]) + digitos;
        return Number(mantisa + "e" + exponente.toString());
    }
    let absNumero = Math.abs(numero);
    let signo = Math.sign(numero);
    if (sp) {
        let n = Math.floor(Math.log2(absNumero));
        let spacing = Math.pow(2, n) * Number.EPSILON;
        if (spacing < Math.pow(10, -digitos - 1)) {
            absNumero += spacing;
        }
    }
    let entero = Math.round(toExp(absNumero, digitos));
    return signo * toExp(entero, -digitos);
},

     cerrarDialogoSalida(item){
       this.salidaDeContratoDialog = item.salidaContrato
       this.dialogConfirmarSalida = true
       this.embarcacionDialog = item.embarcacion.nombre;
       this.folioDialog = item.folioPmx
       this.idDialog = item._id
       this.entradaDialog = item.entradaEscala
     },

    cancelarDialog(item) {
        this.dialog = false;
        this.dialogCotizacion = false;
        this.dialogEstimacion = false;
        this.dialogFacturacion = false;
        this._id = ''
        this.limpiar()
      },
  }
}
</script>

<style>
#factura {
  padding: 20px;
  font-family: Arial, sans-serif;
  font-size: 16px;
}

#table_agencia {
  margin-right: 10px;
}
#imagen {
  width: 100px;
}
#imagen2 {
  width: 90px;
}

#fact {
  font-size: 14px;

  text-align: center;
}

#datos {
  float: left;
  margin-top: 0%;
  margin-left: 15%;
  margin-right: 2%;
  /*text-align: justify;*/
}

#encabezado {
  text-align: center;
  margin-left: 10px;
  margin-right: 10px;
  font-size: 16px;
}

section {
  clear: left;
}

#cliente {
  text-align: left;
}

#facliente {
  width: 40%;
  border-collapse: collapse;
  border-spacing: 0;
  margin-bottom: 15px;
}

#fa {
  color: #ffffff;
  font-size: 14px;
}

#fa2 {
  color: #ffffff;
  font-size: 14px;
}

#facarticulo {
  width: 90%;
  border-collapse: collapse;
  border-spacing: 0;
  padding: 20px;
  margin-bottom: 15px;
  border: 0.5px solid #ddd;
}

#facarticulo thead {
  padding: 20px;
  background: #31467c;
  text-align: center;
  border-bottom: 1px solid #ffffff;
}

#solicitante {
  width: 60%;
  border-collapse: collapse;
  border-spacing: 1;
  padding: 20px;
  margin-bottom: 15px;
  border: 0.5px solid #ddd;
}

#solicitante thead {
  padding: 20px;
  background: #31467c;
  text-align: center;

  border-bottom: 1px solid #ffffff;
}

#gracias {
  text-align: center;
}
#tituloSolicitante {
  background-color: #808285;
  border: 1px solid #ddd;
  color: #ffffff;
}
#tituloPasajeros {
  background-color: #808285;
  border: 1px solid #ddd;
  color: #ffffff;
}
.switch .v-label{
  font-size:12px
}
.inputPequeño .v-label {
  font-size:14px
}
@media screen {
  #print {
    display: none;
   }
}

@media print {
 body * {
  visibility:hidden;
  }
  #print, #print * {
    visibility:visible;
  }
  #print {
    position:absolute;
    left:0;
    top:0;
  }
}
</style>